import { Clock, MapPin, Phone, Mail } from "lucide-react";

const PracticalInfo = () => {

  return (
    <section className="py-12 section-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-2xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>Informazioni Utili</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {/* Orari */}
          <div className="bg-card rounded-2xl p-8 shadow-[var(--shadow-medium)] animate-fade-in-up border border-border">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Clock className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-2xl font-heading font-semibold text-foreground">
                Orari di Apertura
              </h3>
            </div>
            <div className="space-y-3 text-muted-foreground">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-0 pb-3 border-b border-border">
                <span className="font-medium">Lunedì - Venerdì</span>
                <span className="text-sm sm:text-base">8:00 - 13:00, 15:30 - 19:30</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-0 pb-3 border-b border-border">
                <span className="font-medium">Sabato</span>
                <span className="text-sm sm:text-base">8:00 - 13:00</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-0">
                <span className="font-medium">Domenica</span>
                <span className="text-destructive text-sm sm:text-base">Chiuso</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mt-4 italic">
              *Gli orari potrebbero subire variazioni durante i festivi
            </p>
          </div>

          {/* Contatti */}
          <div className="bg-card rounded-2xl p-8 shadow-[var(--shadow-medium)] animate-fade-in-up border border-border" style={{ animationDelay: "0.1s" }}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-2xl font-heading font-semibold text-foreground">
                I Nostri Contatti
              </h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-foreground">Indirizzo</p>
                  <p className="text-muted-foreground">Viale Umbria 21, 06063 Magione (PG)</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-foreground">Telefono</p>
                  <a href="tel:+393466257639" className="text-primary hover:text-primary-light">
                    +39 346 625 7639
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-foreground">Email</p>
                  <a href="mailto:mangimirubini@gmail.com" className="text-primary hover:text-primary-light">
                    mangimirubini@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PracticalInfo;
